import { IconCheckCircleFilled } from '@iwoca/icons';
import { toast } from 'react-toastify';

const SuccessToast = ({ message }: { message: string }) => (
  <>
    <IconCheckCircleFilled aria-hidden />
    <span>{message}</span>
  </>
);

export const showSuccessToast = (message: string) =>
  toast.success(<SuccessToast message={message} />, {
    closeButton: false,
  });
